// extracted by mini-css-extract-plugin
export default {"oneNewItem":"OneNewItem_oneNewItem__eZr7C","oneNewItemIcon":"OneNewItem_oneNewItemIcon__ewmEE","oneNewItemText":"OneNewItem_oneNewItemText__4MgP4"};